import ResultTable from "../../Table/ResultTable";
import {MessageCodes} from "../MessageCodes";
import numWords from "num-words";
import ToUpper from "../ToUpper";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";
import CheckCSName from "../../CheckCSName";
import {Comment} from "antd";

const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.NR001.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) cross sections at the following river stations are removed
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.NR002.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) new cross sections are added at the following river stations.
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.NRICS001.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) Internal Bridge Cross Sections at the following river stations are removed
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.NRICS002.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) new Internal Bridge Cross Sections are added at the following river stations.
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}


export const C1 = {
    RenderDescription,
}